import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {ArmadoresModel} from "./armadores.model";
import {ArmadoresService} from './armadores.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-armadores-form',
  templateUrl: './armadores-form.component.html'
})
export class ArmadoresFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  armador: ArmadoresModel = new ArmadoresModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private armadoresService: ArmadoresService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_armador'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.visualizarArmador');
      }else{
        this.title = id ? this.func.traduzir('front.editarArmador') : this.func.traduzir('front.cadastrarNovoArmador');
      }

      if (!id) {
        return;
      }

      this.armadoresService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarArmador')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarArmador') + ': ' + json.Payload[0].nome;
            }

            this.armador = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.armadoresService.editar(values, values.id);
    } else {
      result = this.armadoresService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'armadores']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if(json.Message && json.Message.ErrorInput){
          for(let i in json.Message.ErrorInput){
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/armadores/armadores-form.component.ts